(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementDialogController', StatementDialogController);

    StatementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Statement', 'Utente', 'Queue', 'StatementType', 'Campagna', 'Agenzia', 'User'];

    function StatementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Statement, Utente, Queue, StatementType, Campagna, Agenzia, User) {
        var vm = this;

        vm.statement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.utentes = Utente.query();
        vm.queues = Queue.query();
        vm.statement_types = StatementType.query();
        vm.campagnas = Campagna.query();
        vm.agenzias = Agenzia.query();
        vm.jhi_users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.statement.id !== null) {
                Statement.update(vm.statement, onSaveSuccess, onSaveError);
            } else {
                Statement.save(vm.statement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:statementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtIns = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
